
window.CKEDITOR_BASEPATH = '/ckeditor/';
console.log('initializing ckeditor');


// WEBPACK FOOTER //
// ./src/js/ckeditor-init.js